/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */

import { LOCALE_ID, Provider } from '@angular/core';
import { OSKLocaleService } from '../../services/locale.service';

class OSKLocaleId extends String {
  constructor(private localeService: OSKLocaleService) {
    super();
  }

  override toString(): string {
    return this.localeService.locale();
  }

  override valueOf(): string {
    return this.toString();
  }
}

/**
 * @override Overrides the {@link LOCALE_ID} Injection token to return the locale saved in the {@link OSKLocaleService}
 */
export const OSKLocaleIdProvider: Provider = {
  provide: LOCALE_ID,
  useClass: OSKLocaleId,
  deps: [OSKLocaleService]
};
